<form [formGroup]="componentInformationFormGroup">
  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass != 8 && componentMAWP.strD_iclass != 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="comboBox0_DI_EquipInfo" *ngIf="componentMAWP.strD_iclass == 5"
        >Component type:</label
      >
    </div>
    <div class="col-sm-4">
      <select
        id="comboBox0_DI_EquipInfo"
        class="form-control form-control-sm"
        (change)="onChangeComboBox0_DI_EquipInfo($event.target.value)"
        formControlName="comboBox0_DI_EquipInfo"
      >
        <option *ngFor="let data of ComboBox0Data" [value]="data.text">
          {{ data.text }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 5 || componentMAWP.strD_iclass == 8"
  >
    <div class="col-sm-8 align-self-center">
      <label
        for="textBox1_DI_EquipInfo"
        *ngIf="componentMAWP.strD_iclass == 5"
        [ngClass]="this.textBox1_DI_EquipInfo_Enabled ? '' : 'disabled'"
        >Inside diameter corrected for FCA as applicable, D&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(inch)</span
        ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
      >
      <label
        for="textBox1_DI_EquipInfo"
        *ngIf="componentMAWP.strD_iclass == 8"
        [ngClass]="this.textBox1_DI_EquipInfo_Enabled ? '' : 'disabled'"
        >Maximum operating pressure, P_op&nbsp;<span *ngIf="this.intUnit === 0"
          >(psi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
    </div>
    <div class="col-sm-4">
      <input
        appRestrictInput
        type="number"
        name="insideDiameterFCA"
        (change)="onChangeTextBox1_DI_EquipInfo($event)"
        id="textBox1_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox1_DI_EquipInfo"
        min="0"
      />
    </div>
  </div>
  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass != 6"
  >
    <div class="col-sm-8 align-self-center">
      <label
        for="TextBox2_DI_EquipInfo"
        *ngIf="
          componentMAWP.strD_iclass == 5 &&
          componentMAWP.strD_class == 'Blister'
        "
        >Current measured uniform thickness away from blister, trd&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(inch)</span
        ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
      >
      <label
        for="TextBox2_DI_EquipInfo"
        *ngIf="
          componentMAWP.strD_iclass == 5 && componentMAWP.strD_class == 'HIC'
        "
        >Current measured uniform thickness away from HIC, trd&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(inch)</span
        ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
      >
      <label
        for="TextBox2_DI_EquipInfo"
        *ngIf="
          componentMAWP.strD_iclass == 8 &&
          componentMAWP.strD_class == 'DentGouge'
        "
        >Specified minimum yield strength, SMYS&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(ksi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
    </div>
    <div class="col-sm-4">
      <input
        appRestrictInput
        type="number"
        name="currentMeasuredUniformThickness"
        (change)="onChangeTextBox2_DI_EquipInfo($event)"
        id="TextBox2_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox2_DI_EquipInfo"
        min="0"
      />
    </div>
  </div>

  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label
        for="comboBox1_DI_EquipInfo"
        [ngClass]="this.comboBox1_DI_EquipInfo_Enabled ? '' : 'disabled'"
        >Weld orientation:</label
      >
    </div>
    <div class="col-sm-4">
      <select
        labelDisable
        id="comboBox1_DI_EquipInfo"
        class="form-control form-control-sm"
        (change)="onChangeComboBox1_DI_EquipInfo($event.target.value)"
        formControlName="comboBox1_DI_EquipInfo"
      >
        <option *ngFor="let data of ComboBox1Data" [value]="data.text">
          {{ data.text }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="comboBox2_DI_EquipInfo"
        >Post Weld Heat Treatment, PWHT:</label
      >
    </div>
    <div class="col-sm-4">
      <select
        id="comboBox2_DI_EquipInfo"
        class="form-control form-control-sm"
        (change)="onChangeComboBox2_DI_EquipInfo($event.target.value)"
        formControlName="comboBox2_DI_EquipInfo"
      >
        <option *ngFor="let data of ComboBox2Data" [value]="data.text">
          {{ data.text }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="comboBox3_DI_EquipInfo"
        >ASME exemption curve for the base material:</label
      >
    </div>
    <div class="col-sm-4">
      <select
        id="comboBox3_DI_EquipInfo"
        class="form-control form-control-sm"
        (change)="onChangeComboBox3_DI_EquipInfo($event.target.value)"
        formControlName="comboBox3_DI_EquipInfo"
      >
        <option *ngFor="let data of ComboBox3Data" [value]="data.text">
          {{ data.text }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-group row align-items-center">
    <div class="col-sm-8 align-self-center">
      <label for="TextBox3_DI_EquipInfo" *ngIf="componentMAWP.strD_iclass == 5"
        >Future Corrosion Allowance, FCA&nbsp;<span *ngIf="this.intUnit === 0"
          >(inch)</span
        ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
      >
      <label for="TextBox3_DI_EquipInfo" *ngIf="componentMAWP.strD_iclass == 6"
        >Specified minimum yield strength for the base material, SMYS&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(ksi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
      <label
        for="TextBox3_DI_EquipInfo"
        *ngIf="
          componentMAWP.strD_iclass == 8 &&
          componentMAWP.strD_class == 'DentGouge'
        "
        >Circumferential stress for the component based on trd-FCA,
        Sigma&nbsp;<span *ngIf="this.intUnit === 0">(ksi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
    </div>
    <div class="col-sm-4">
      <input
        appRestrictInput
        type="number"
        name="futureCorrosionAllowance"
        (change)="onChangeTextBox3_DI_EquipInfo($event)"
        id="TextBox3_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox3_DI_EquipInfo"
        min="0"
      />
    </div>
  </div>

  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="TextBox4_DI_EquipInfo"
        >Specified minimum tensile strength for the base material,
        SMTS&nbsp;<span *ngIf="this.intUnit === 0">(ksi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
    </div>
    <div class="col-sm-4">
      <input
        appRestrictInput
        type="number"
        name="futureCorrosionAllowance"
        (change)="onChangeTextBox4_DI_EquipInfo($event)"
        id="TextBox4_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox4_DI_EquipInfo"
        min="0"
      />
    </div>
  </div>

  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="TextBox5_DI_EquipInfo"
        >Allowable stress for the base material, Sigma_a&nbsp;<span
          *ngIf="this.intUnit === 0"
          >(ksi)</span
        ><span *ngIf="this.intUnit === 1">(MPa)</span>:</label
      >
    </div>
    <div class="col-sm-4">
      <input
        appRestrictInput
        type="number"
        name="futureCorrosionAllowance"
        (change)="onChangeTextBox5_DI_EquipInfo($event)"
        id="TextBox5_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox5_DI_EquipInfo"
        readonly
        min="0"
      />
    </div>
  </div>

  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="TextBox6_DI_EquipInfo"
        >Critical exposure temperature (CET) or assessment
        temperature&nbsp;<span *ngIf="this.intUnit === 0">(°F)</span
        ><span *ngIf="this.intUnit === 1">(°C)</span>:
      </label>
    </div>
    <div class="col-sm-4">
      <input
        type="number"
        name="futureCorrosionAllowance"
        (change)="onChangeTextBox6_DI_EquipInfo($event)"
        id="TextBox6_DI_EquipInfo"
        class="form-control form-control-sm"
        formControlName="textBox6_DI_EquipInfo"
      />
    </div>
  </div>

  <div
    class="form-group row align-items-center"
    *ngIf="componentMAWP.strD_iclass == 6"
  >
    <div class="col-sm-8 align-self-center">
      <label for="comboBox1_DI_EquipInfo_new"
        >Carbon Steel Sulfur Content:</label
      >
    </div>
    <div class="col-sm-4">
      <select
        id="comboBox1_DI_EquipInfo_new"
        class="form-control form-control-sm"
        (change)="onChangeComboBox1_DI_EquipInfo_new($event.target.value)"
        formControlName="comboBox1_DI_EquipInfo_new"
      >
        <option *ngFor="let data of ComboBox1NewData" [value]="data.text">
          {{ data.text }}
        </option>
      </select>
    </div>
  </div>
</form>
